"use strict";

var _Object$keys = require("@babel/runtime-corejs2/core-js/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors");
var _Object$defineProperties = require("@babel/runtime-corejs2/core-js/object/define-properties");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _Array$from = require("@babel/runtime-corejs2/core-js/array/from");
var _Symbol = require("@babel/runtime-corejs2/core-js/symbol");
var _Symbol$iterator = require("@babel/runtime-corejs2/core-js/symbol/iterator");
var _Array$isArray = require("@babel/runtime-corejs2/core-js/array/is-array");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));
var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));
var _stringify = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/json/stringify"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));
var _cloneDeep2 = _interopRequireDefault(require("lodash/cloneDeep"));
var _webexCore = require("@webex/webex-core");
var _common = require("@webex/common");
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof _Symbol !== "undefined" && o[_Symbol$iterator] || o["@@iterator"]; if (!it) { if (_Array$isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return _Array$from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }
var debug = require('debug')('rooms');

/**
 * @typedef {Object} RoomObject
 * @property {string} id - (server generated) Unique identifier for the room
 * @property {string} title - The display name for the room. All room members
 * will see the title so make it something good
 * @property {string} teamId - (optional) The ID of the team to which the room
 * belongs
 * @property {isoDate} created - (server generated) The date and time that the
 * room was created
 */

/**
 * Rooms are virtual meeting places for getting stuff done. This resource
 * represents the room itself. Check out the {@link Memberships} API to learn
 * how to add and remove people from rooms and the {@link Messages} API for
 * posting and managing content.
 * @class
 * @name Rooms
 */
var Rooms = _webexCore.WebexPlugin.extend({
  /**
   * Register to listen for incoming rooms events
   * This is an alternate approach to registering for rooms webhooks.
   * The events passed to any registered handlers will be similar to the webhook JSON,
   * but will omit webhook specific fields such as name, secret, url, etc.
   * To utilize the `listen()` method, the authorization token used
   * will need to have `spark:all` and `spark:kms` scopes enabled.
   * Note that by configuring your application to enable or disable `spark:all`
   * via its configuration page will also enable or disable `spark:kms`.
   * See the <a href="https://webex.github.io/webex-js-sdk/samples/browser-socket/">Sample App</a>
   * for more details.
   * @instance
   * @memberof Rooms
   * @returns {Promise}
   * @example
   * webex.rooms.listen()
   *   .then(() => {
   *     console.log('listening to room events');
   *     webex.rooms.on('created', (event) => console.log(`Got a room:created event:\n${event}`);
   *     webex.rooms.on('updated', (event) => console.log(`Got a room:updated event:\n${event}`);
   *   })
   *   .catch((e) => console.error(`Unable to register for room events: ${e}`));
   * // Some app logic...
   * // WHen it is time to cleanup
   * webex.rooms.stopListening();
   * webex.rooms.off('created');
   * webex.rooms.off('updated');
   */
  listen: function listen() {
    var _this = this;
    return (0, _common.createEventEnvelope)(this.webex, _common.SDK_EVENT.EXTERNAL.RESOURCE.ROOMS).then(function (envelope) {
      _this.eventEnvelope = envelope;
      return _this.webex.internal.mercury.connect().then(function () {
        _this.listenTo(_this.webex.internal.mercury, _common.SDK_EVENT.INTERNAL.WEBEX_ACTIVITY, function (event) {
          return _this.onWebexApiEvent(event);
        });
      });
    });
  },
  /**
   * Creates a new room. The authenticated user is automatically added as a
   * member of the room. See the {@link Memberships} API to learn how to add
   * more people to the room.
   * @instance
   * @memberof Rooms
   * @param {RoomObject} room
   * @returns {Promise<RoomObject>}
   * @example
   * webex.rooms.create({title: 'Create Room Example'})
   *   .then(function(room) {
   *     var assert = require('assert')
   *     assert(typeof room.created === 'string');
   *     assert(typeof room.id === 'string');
   *     assert(room.title === 'Create Room Example');
   *     console.log(room.title);
   *     return 'success';
   *   });
   *   // => success
   */
  create: function create(room) {
    return this.request({
      method: 'POST',
      service: 'hydra',
      resource: 'rooms',
      body: room
    }).then(function (res) {
      return res.body;
    });
  },
  /**
   * Returns a single room.
   * @instance
   * @memberof Rooms
   * @param {RoomObject|string} room
   * @param {Object} options
   * @returns {Promise<RoomObject>}
   * @example
   * var room;
   * webex.rooms.create({title: 'Get Room Example'})
   *   .then(function(r) {
   *     room = r
   *     return webex.rooms.get(room.id)
   *   })
   *   .then(function(r) {
   *     var assert = require('assert');
   *     assert.deepEqual(r, room);
   *     return 'success';
   *   });
   *   // => success
   */
  get: function get(room, options) {
    var id = room.id || room;
    return this.request({
      service: 'hydra',
      resource: "rooms/".concat(id),
      qs: options
    }).then(function (res) {
      return res.body.items || res.body;
    });
  },
  /**
   * Returns a list of rooms. In most cases the results will only contain rooms
   * that the authenticated user is a member of.
   * @instance
   * @memberof Rooms
   * @param {Object} options
   * @param {Object} options.max Limit the maximum number of rooms in the
   * response.
   * @returns {Promise<Page<RoomObject>>}
   * @example
   * var createdRooms;
   * Promise.all([
   *   webex.rooms.create({title: 'List Rooms Example 1'}),
   *   webex.rooms.create({title: 'List Rooms Example 2'}),
   *   webex.rooms.create({title: 'List Rooms Example 3'})
   * ])
   *   .then(function(r) {
   *     createdRooms = r;
   *     return webex.rooms.list({max: 3})
   *       .then(function(rooms) {
   *         var assert = require('assert');
   *         assert(rooms.length === 3);
   *         for (var i = 0; i < rooms.items.length; i+= 1) {
   *           assert(createdRooms.filter(function(room) {
   *             return room.id === rooms.items[i].id;
   *           }).length === 1);
   *         }
   *         return 'success';
   *       });
   *   });
   *   // => success
   */
  list: function list(options) {
    var _this2 = this;
    return this.request({
      service: 'hydra',
      resource: 'rooms/',
      qs: options
    }).then(function (res) {
      return new _webexCore.Page(res, _this2.webex);
    });
  },
  /**
   * Returns a list of rooms with details about the data of the last
   * activity in the room, and the date of the users last presences in
   * the room. The list is sorted with this with most recent activity first
   *
   * For rooms where lastActivityDate > lastSeenDate the space
   * can be considered to be "unread"
   *
   * This differs from the rooms.list() function in the following ways:
   *  -- when called with no parameters it returns an array of all
   *     spaces, up to 1000, that the user is a member of
   *  -- pagination is not supported. ALL rooms are returned which
   *     can result in a large payload
   *  -- For users with hundreds of spaces, this API can take some time to
   *     to return, for this reason it supports an optional maxRecent parameter.
   *     If set this will return only the specified number of spaces with activity
   *     in the last two weeks.  Recommended value is 30.  Max supported is 100.
   *  -- only "id", "type", "lastActivityDate", and "lastSeenDate" are
   *     guaranteed to be available for each room in the list
   *  -- "title" is usually returned, but not guaranteed
   *
   * In general this function should be used only when the client needs to
   * access read status info, for example on startup.
   * After startup, clients should track message and membership:seen events
   * to maintain read status client side.
   *
   * Since this API can take some time to return up to 1000 spaces, it is
   * recommended that custom clients call this first with the maxRecent parameter
   * set to 30, so that they can display some of the more recents spaces.  Calling
   * this API a second time with no parameters will return all the spaces.
   *
   * Not all spaces may be returned, for example when users in more than 1000
   * spaces, or when a new spaces is added after this function is called,
   * but before it returns. Custom clients should be prepared to gracefully
   * handle cases where an event occurs in a space not returned by this call,
   * by querying rooms.getWithReadStatus() with the id of the room in question
   *
   * This function may be deprecated when this info is provided in the membership
   * objects returned in the list function.
   * @instance
   * @param {int} maxRecent
   * @memberof Rooms
   * @returns {Promise<RoomInfoObjectList>}
   */
  listWithReadStatus: function listWithReadStatus() {
    var _arguments = arguments,
      _this3 = this;
    return (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var maxRecent, now, options;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            maxRecent = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : 0;
            now = new Date();
            options = {
              activitiesLimit: 0,
              computeTitleIfEmpty: true,
              conversationsLimit: 1000,
              isActive: true
            };
            if (!(maxRecent > 0)) {
              _context.next = 8;
              break;
            }
            options.conversationsLimit = maxRecent;
            options.sinceDate = now.setDate(now.getDate() - 14);
            _context.next = 10;
            break;
          case 8:
            if (!(maxRecent < 0 || maxRecent > 100)) {
              _context.next = 10;
              break;
            }
            return _context.abrupt("return", _promise.default.reject(new Error('rooms.listWithReadStatus: ' + 'optional maxRecent parameter must be an integer between 1 and 100')));
          case 10:
            return _context.abrupt("return", _this3.webex.internal.services.waitForCatalog('postauth').then(function () {
              return _this3.webex.internal.conversation.list(options);
            }).then(function (conversations) {
              return buildRoomInfoList(_this3.webex, conversations);
            }));
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  /**
   * Returns a single room object with details about the data of the last
   * activity in the room, and the date of the users last presence in
   * the room.
   *
   * For rooms where lastActivityDate > lastSeenDate the room
   * can be considered to be "unread"
   *
   * This differs from the rooms.get() function in the following ways:
   *  -- it takes a single roomId parameter to fetch
   *  -- no other options are considered
   *  -- only "id", "type", "lastActivityDate", and "lastSeenDate" are
   *     guaranteed to be available in the return object
   *  -- "title" is usually returned, but not guaranteed
   *
   * In general clients should use the listWithReadStatus() method on startup
   * to get the initial roomStatus and then update their client side copy by
   * responding to message, membership and room events.
    * This function allows a custom client to be "nimble" if it is responding
   * to an event with a roomId that was not in the original fetch.  The
   * anticipated behavior is that getWithReadStats is called "just in time",
   * with the resulting room object being added to the list of cached room
   * objects on the client side.
   *
   * This function may be deprecated when this info is provided in the room
   * object returned in the get function.
   * @instance
   * @memberof Rooms
   * @param {string} roomId
   * @returns {Promise<RoomInfoObject>}
   */
  getWithReadStatus: function getWithReadStatus(roomId) {
    var _this4 = this;
    var deconstructedId = (0, _common.deconstructHydraId)(roomId);
    var conversation = {
      id: deconstructedId.id,
      cluster: deconstructedId.cluster
    };
    return this.webex.internal.services.waitForCatalog('postauth').then(function () {
      return _this4.webex.internal.conversation.get(conversation, {
        computeTitleIfEmpty: true,
        activitiesLimit: 0 // don't send the whole history of activity
      }).then(function (convo) {
        return buildRoomInfo(_this4.webex, convo);
      });
    });
  },
  /**
   * Deletes a single room.
   * @instance
   * @memberof Rooms
   * @param {RoomObject|string} room
   * @returns {Promise}
   * @example
   * var room;
   * webex.rooms.create({title: 'Remove Room Example'})
   *  .then(function(r) {
   *    room = r;
   *    return webex.rooms.remove(room.id);
   *  })
   *  .then(function() {
   *    return webex.rooms.get(room.id);
   *  })
   *  .then(function() {
   *    var assert = require('assert');
   *    assert(false, 'the previous get should have failed');
   *  })
   *  .catch(function(reason) {
   *    var assert = require('assert');
   *    assert.equal(reason.statusCode, 404);
   *    return 'success'
   *  });
   *  // => success
   */
  remove: function remove(room) {
    var id = room.id || room;
    return this.request({
      method: 'DELETE',
      service: 'hydra',
      resource: "rooms/".concat(id)
    }).then(function (res) {
      // Firefox has some issues with 204s and/or DELETE. This should move to
      // http-core
      if (res.statusCode === 204) {
        return undefined;
      }
      return res.body;
    });
  },
  /**
   * Used to update a single room's properties.
   * @instance
   * @memberof Rooms
   * @param {RoomObject} room
   * @returns {Promise<RoomObject>}
   * @example
   * var room;
   * webex.rooms.update({title: 'Update Room Example'})
   *   .then(function(r) {
   *     room = r;
   *     room.title = 'Update Room Example (Updated Title)';
   *     return webex.rooms.update(room);
   *   })
   *   .then(function() {
   *     return webex.rooms.get(room.id);
   *   })
   *   .then(function(room) {
   *    var assert = require('assert');
   *     assert.equal(room.title, 'Update Room Example (Updated Title)');
   *     return 'success';
   *   });
   *   // => success
   */
  update: function update(room) {
    var id = room.id;
    return this.request({
      method: 'PUT',
      service: 'hydra',
      resource: "rooms/".concat(id),
      body: room
    }).then(function (res) {
      return res.body;
    });
  },
  /**
   * This function is called when an internal membership events fires,
   * if the user registered for these events with the listen() function.
   * External users of the SDK should not call this function
   * @private
   * @memberof Rooms
   * @param {Object} event
   * @returns {void}
   */
  onWebexApiEvent: function onWebexApiEvent(event) {
    var activity = event.data.activity;

    /* eslint-disable no-case-declarations */
    switch (activity.verb) {
      case _common.SDK_EVENT.INTERNAL.ACTIVITY_VERB.CREATE:
        var roomCreatedEvent = this.getRoomEvent(this.webex, activity, _common.SDK_EVENT.EXTERNAL.EVENT_TYPE.CREATED);
        if (roomCreatedEvent) {
          debug("room \"created\" payload:             ".concat((0, _stringify.default)(roomCreatedEvent)));
          this.trigger(_common.SDK_EVENT.EXTERNAL.EVENT_TYPE.CREATED, roomCreatedEvent);
        }
        break;
      case _common.SDK_EVENT.INTERNAL.ACTIVITY_VERB.UPDATE:
      case _common.SDK_EVENT.INTERNAL.ACTIVITY_VERB.LOCK:
      case _common.SDK_EVENT.INTERNAL.ACTIVITY_VERB.UNLOCK:
        debug("generating a rooms:updated based on ".concat(activity.verb, " activity"));
        var roomUpdatedEvent = this.getRoomEvent(this.webex, activity, _common.SDK_EVENT.EXTERNAL.EVENT_TYPE.UPDATED);
        if (roomUpdatedEvent) {
          debug("room \"updated\" payload:             ".concat((0, _stringify.default)(roomUpdatedEvent)));
          this.trigger(_common.SDK_EVENT.EXTERNAL.EVENT_TYPE.UPDATED, roomUpdatedEvent);
        }
        break;
      default:
        break;
    }
  },
  /**
   * Constructs the data object for an event on the rooms resource,
   * adhering to Hydra's Webhook data structure.
   * External users of the SDK should not call this function
   * @private
   * @memberof Rooms
   * @param {Object} webex sdk instance
   * @param {Object} activity from mercury
   * @param {Object} event type of "webhook" event
   * @returns {Object} constructed event
   */
  getRoomEvent: function getRoomEvent(webex, activity, event) {
    try {
      var sdkEvent = (0, _cloneDeep2.default)(this.eventEnvelope);
      var cluster = (0, _common.getHydraClusterString)(webex, activity.url);
      var tags = activity.object.tags;
      sdkEvent.event = event;
      sdkEvent.data.created = activity.published;
      sdkEvent.actorId = (0, _common.buildHydraPersonId)(activity.actor.entryUUID, cluster);
      if (activity.object.id) {
        sdkEvent.data.id = (0, _common.buildHydraRoomId)(activity.object.id, cluster);
      } else {
        sdkEvent.data.id = (0, _common.buildHydraRoomId)(activity.target.id, cluster);
      }
      if (event === _common.SDK_EVENT.EXTERNAL.EVENT_TYPE.CREATED) {
        sdkEvent.data.creatorId = (0, _common.buildHydraPersonId)(activity.actor.entryUUID, cluster);
        sdkEvent.data.lastActivity = activity.published;
      } else if (event === _common.SDK_EVENT.EXTERNAL.EVENT_TYPE.UPDATED) {
        if (activity.verb === 'update') {
          // For some reason the tags are not in the object for an update activity
          tags = activity.target.tags;
        }
        if (activity.object.creatorUUID) {
          // This seems to be set in lock/unlock activities but not updated...
          debug("Found a creatorId: ".concat(activity.object.creatorUUID, " in a ").concat(activity.verb, " event"));
          sdkEvent.data.creatorId = (0, _common.buildHydraPersonId)(activity.object.creatorUUID, cluster);
        }
        // Webhook engine team sets this based on lastReadableActivityDate
        // in the activity.target object.  See: hydra/HydraRoom.java#L51
        // This elements seems to be missing from the activity that the SDK is getting
        // sdkEvent.data.lastActivity = activity.target.lastReadableActivityDate;
      } else {
        throw new Error('unexpected event type');
      }
      sdkEvent.data.type = (0, _common.getHydraRoomType)(tags);
      sdkEvent.data.isLocked = tags.includes(_common.SDK_EVENT.INTERNAL.ACTIVITY_TAG.LOCKED);
      return sdkEvent;
    } catch (e) {
      this.webex.logger.error("Unable to generate SDK event from mercury socket activity for rooms:".concat(event, " event: ").concat(e.message));
      return null;
    }
  },
  version: "2.59.8"
});
var _default = Rooms;
/**
 * Helper method to build a roomInfo object from a conversation object
 * @param {Object} webex sdk object
 * @param {Conversation~ConversationObject} conversation
 * @returns {Promise<RoomInfoObject>}
 */
exports.default = _default;
function buildRoomInfo(_x, _x2) {
  return _buildRoomInfo.apply(this, arguments);
}
/**
 * Helper method to build a list of roomInfo object from conversation list
 * @param {Object} webex sdk object
 * @param {Conversation~ConversationObjectList} conversations
 * @returns {Promise<RoomInfoList>}
 */
function _buildRoomInfo() {
  _buildRoomInfo = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(webex, conversation) {
    var type, cluster, title, lastActivityDate, roomInfo;
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          type = (0, _common.getHydraRoomType)(conversation.tags);
          cluster = (0, _common.getHydraClusterString)(webex, conversation.url);
          title = conversation.displayName ? conversation.displayName : conversation.computedTitle;
          lastActivityDate = conversation.lastReadableActivityDate ? conversation.lastReadableActivityDate : conversation.lastRelevantActivityDate;
          roomInfo = _objectSpread(_objectSpread(_objectSpread({
            id: (0, _common.buildHydraRoomId)(conversation.id, cluster),
            type: type
          }, title && {
            title: conversation.displayName
          }), lastActivityDate && {
            lastActivityDate: lastActivityDate
          }), {}, {
            lastSeenActivityDate: conversation.lastSeenActivityDate ? conversation.lastSeenActivityDate :
            // If user has never been seen set the date to "a long time ago"
            new Date(0).toISOString()
          });
          return _context2.abrupt("return", _promise.default.resolve(roomInfo));
        case 9:
          _context2.prev = 9;
          _context2.t0 = _context2["catch"](0);
          return _context2.abrupt("return", _promise.default.reject(_context2.t0));
        case 12:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[0, 9]]);
  }));
  return _buildRoomInfo.apply(this, arguments);
}
function buildRoomInfoList(_x3, _x4) {
  return _buildRoomInfoList.apply(this, arguments);
}
function _buildRoomInfoList() {
  _buildRoomInfoList = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(webex, conversations) {
    var roomReadInfo, roomInfoPromises, _iterator, _step, conversation;
    return _regenerator.default.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          // Convert each Conversation into a roomInfo object
          roomReadInfo = {
            items: []
          };
          roomInfoPromises = [];
          _iterator = _createForOfIteratorHelper(conversations);
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              conversation = _step.value;
              roomInfoPromises.push(buildRoomInfo(webex, conversation));
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          return _context3.abrupt("return", _promise.default.all(roomInfoPromises).then(function (roomInfoList) {
            roomReadInfo.items = roomInfoList;
            roomReadInfo.items.sort(function (a, b) {
              return a.lastActivityDate < b.lastActivityDate ? 1 : -1;
            });
            return roomReadInfo;
          }));
        case 5:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _buildRoomInfoList.apply(this, arguments);
}
//# sourceMappingURL=rooms.js.map
